export default __webpack_public_path__ + "2860932e436c6dce15ca045617a108a7.svg";